import { Injectable } from "@angular/core";
import { HttpClientService } from "./http-client.service";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

/** Base64 data URL payload for multipart-less comment attachments (backend uploads to Drive). */
export interface CommentAttachmentPayload {
  original_filename: string;
  content: string;
}

@Injectable()
export class CommentsService {
  constructor(private http: HttpClientService) {}

  public getCommentsByResourceIdAndCommentableType(
    commentable_type: any,
    commentable_id: any,
    type: string = undefined
  ): Observable<any> {
    const options = {
      params: {
        commentable_type,
        commentable_id,
        type,
      },
    };
    return this.http
      .get("/api/comments/comments_by_resource", options)
      .pipe(tap((_) => console.log("CommentsService.getCommentsByResourceIdAndCommentableType: Ok.")));
  }

  public createComment(
    text: string,
    commentable_type: string,
    commentable_id: string | number,
    type: string = undefined,
    document_id?: number | null
  ) {
    return this.postCreateComment({
      text,
      commentable_type,
      commentable_id,
      type,
      document_id: document_id != null ? document_id : undefined,
    });
  }

  public createCommentWithAttachments(
    text: string,
    commentable_type: string,
    commentable_id: string | number,
    type: string | undefined,
    attachments: ReadonlyArray<CommentAttachmentPayload>
  ): Observable<any> {
    return this.postCreateComment({
      text,
      commentable_type,
      commentable_id,
      type,
      attachments: [...attachments],
    });
  }

  private postCreateComment(payload: {
    text: string;
    commentable_type: string;
    commentable_id: string | number;
    type?: string;
    document_id?: number;
    attachments?: ReadonlyArray<CommentAttachmentPayload>;
  }): Observable<any> {
    const body: Record<string, unknown> = {
      text: payload.text,
      commentable_type: payload.commentable_type,
      commentable_id: payload.commentable_id,
      type: payload.type,
    };
    if (payload.document_id != null) {
      body["document_id"] = payload.document_id;
    }
    if (payload.attachments != null && payload.attachments.length > 0) {
      body["attachments"] = payload.attachments;
    }
    return this.http.post("/api/comments", body).pipe(tap((_) => console.log("CommentsService.createComment: Ok.")));
  }

  public updateComment(message: string, comment_id: string | number): Observable<any> {
    const options = {
      comment: {
        message,
        id: comment_id,
      },
    };
    return this.http
      .put("/api/comments/comments_by_resource", options)
      .pipe(tap((_) => console.log("CommentsService.updateComment: Ok.")));
  }

  public toogleFavorite(comment_id: string | number): Observable<any> {
    const options = {
      comment: {
        id: comment_id,
      },
    };
    return this.http
      .put("/api/comments/toggle_favorite", options)
      .pipe(tap((_) => console.log("CommentsService.toogleFavorite: Ok.")));
  }
}
